import { Component, Input, OnInit, Renderer2 } from '@angular/core';

@Component({
  selector: 'app-additional-details',
  templateUrl: './additional-details.component.html',
  styleUrls: ['./additional-details.component.scss']
})
export class AdditionalDetailsComponent implements OnInit {
  @Input() formModel:any ={}
  @Input() getAllDropdown:any ={}
  constructor(public renderer: Renderer2) { }

  ngOnInit(): void {
    this.formModel.additionalDetailsModel = this.formModel?.additionalDetailsModel ?? {};
  }
  // for input keydown ------------------
  onKeydown(event: any, value: any) {
    const element = this.renderer.selectRootElement(value, true);
    if (event.key === "Enter") {
      element.focus();
    }
  }

}
